import axios from "axios";

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Attach the auth token to every request automatically
axiosInstance.interceptors.request.use((config) => {
    const stored = localStorage.getItem("user");
    if (stored) {
        try {
            const user = JSON.parse(stored);
            if (user?.token) {
                config.headers["Authorization"] = `Bearer ${user.token}`;
            }
        } catch (_) { }
    }
    return config;
});

// On 401 from auth middleware, clear the session and redirect to login
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const msg = error.response?.data?.error || "";
            // Only redirect if it's a genuine auth failure (from auth middleware)
            const authErrors = [
                "user not authorized",
                "jwt expired",
                "jwt malformed",
                "invalid token",
                "invalid signature",
            ];
            const isAuthError = authErrors.some((e) => msg.toLowerCase().includes(e));
            if (isAuthError) {
                localStorage.removeItem("user");
                if (window.location.pathname !== "/login") {
                    window.location.href = "/login";
                }
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
